import { useRecoilState } from "recoil"
import leftMenuAtom from "recoil/nav/leftMenu";

 const useLeftMenu = () => useRecoilState(leftMenuAtom);

 export default useLeftMenu;